$(document).foundation();


function initMobileMenuControls() {
	var items = $("#menu .l1-item").length;

	$("#menu .l1-item").on("click", function() {
		var itemCount = $(this).find(".sub-menu li").length;

		if (itemCount >= items) {
			$("#menu-wrap .menu-btm").css("transform", "translateY(" + (((itemCount + 1) - items) * 52).toString() + "px)");
		}
	});

	$(document).on("click", "#menu .l1-item .btn-close-sub", function() {
		$("#menu-wrap .menu-btm").css("transform", "none");
	});
}


$(function() {

    //---------------------------------------------------------
    //  Elements
    //---------------------------------------------------------
    if ($('.rellax').length > 0) {
        var rellax = new Rellax('.rellax', {});
    }
    if ($('.parallax-window').length > 0) {
        $('.parallax-window').parallax({
            naturalWidth: 600,
            naturalHeight: 400
          });
    }



    if ($('.content-slider').length > 0) {
        $('.content-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: true,
            appendDots: $('.content-slider-wrap'),
            appendArrows: $('.content-slider-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.image-carousel').length > 0) {
        $('.image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.tile-slider').length > 0) {
        $('.tile-slider').slick({
            infinite: true,
            slidesToShow: $('.tile-slider').data("count"),
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.tile-grid-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }


    if ($('.instagram-slider').length > 0) {
        $('.instagram-slider').slick({
            infinite: true,
            slidesToShow: $('.instagram-slider').data("count"),
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.instagram-grid-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Header functionality
    //---------------------------------------------------------
    if (Foundation.MediaQuery.current == 'small') {
            var threshold = 100;
    } else {
        var threshold = $('#page-heading').hasClass('height-standard') ? 100 : 200;
    }
    if ($(document).scrollTop() > threshold) {
        $('#header').addClass('solid');
    }

    $(window).scroll(function() {
        $( '.fade-content:in-viewport( 900 )' ).addClass('show-content');

        if (Foundation.MediaQuery.current == 'small') {
            var scrollThreshold = 100;
        } else {
            var scrollThreshold = $('#page-heading').hasClass('height-Standard') ? 100 : 200;
        }

        if ($(document).scrollTop() > scrollThreshold) {
            $('#header').addClass('solid');
        }
        else {
            $('#header').removeClass('solid');
        }
    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '.icon-menu', function() {
        $(this).toggleClass('open');
        $('#dropdown-menu').toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
        if ($(this).hasClass('open')) {
            $('#nav-shade').fadeIn(300);
        } else {
            $('#nav-shade').fadeOut(300);
        }
    });

    $(document).on('click', '#nav-shade', function() {
        $('.icon-menu').removeClass('open');
        $('#dropdown-menu').removeClass('open');
        $('#header').removeClass('menu-open');
        $('body').removeClass('menu-open');
        $('#nav-shade').fadeOut(300);
    });

    $(document).on('click', '.sub-menu-expand', function() {
        $(this).toggleClass('open');
        $(this).parent().find('.sub-menu').toggleClass('open');
    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Flyout menu
    //---------------------------------------------------------
    $(document).on('click', '.btn-mobile-menu', function() {
        $(this).toggleClass('open');
        $('body').toggleClass('menu-open');
        $('#flyout-menu').toggleClass('open');
        return false;
    });

    $(document).on('click', '.link-parent-mobile', function() {
        $('.sub-menu').removeClass('mobile-open');
        $(this).parent().next('.sub-menu').addClass('mobile-open');
        $('#menu').addClass('sub-open');
        return false;
    });

    $(document).on('click', '.btn-close-sub', function() {
        $('.sub-menu').removeClass('mobile-open');
        $('#menu').removeClass('sub-open');
    });

	if (window.innerWidth < 700) initMobileMenuControls();
    //---------------------------------------------------------


    // if ($(document.body).hasClass("GalleryPage")){
    //
    //     $(document).on('click', '.gallery-filter', function() {
    //         $(this).toggleClass('active');
    //
    //         filterGallery();
    //     });
    //
    //
    //     function filterGallery() {
    //         $('.masonry-css-item').addClass('hide');
    //
    //         $('.gallery-filter').each(function() {
    //             var filterID = $(this).data("id");
    //
    //             if($(this).hasClass('active')){
    //                 $('.masonry-css-item').each(function() {
    //                     var strKeywords = $(this).data("keyword");
    //                     if (strKeywords.includes(filterID)){
    //                         $(this).removeClass('hide');
    //                     }
    //                 });
    //             }
    //         });
    //
    //     }//End filterGallery
    //
    //
    // }//End GalleryPage

    if ($(document.body).hasClass("WorkPage")){

        $(document).on('click', '.gallery-filter', function() {
            $(".gallery-filter").removeClass('active');
            $(this).addClass('active');
            $(".tile-item").hide();
            $("."+$(this).data('id')).show();
        });

    }//End WorkPage

});



// (() => {
//  'use strict';
//
//  // Create object literal with project variables
//  const galleryVariables = {
//   galleryAuthor: document.querySelector('.js-modal-author'),
//   galleryButton: document.querySelector('.js-close-button'),
//   galleryLinks: document.querySelectorAll('a[data-toggle="galleryModal"]'),
//   galleryModal: document.querySelector('.js-gallery-reveal'),
//   galleryOverlay: document.querySelector('.js-gallery-overlay'),
//   galleryPreview: document.querySelector('.js-modal-preview'),
//   galleryPreviewAuthor: document.querySelector('.js-modal-author')
//  }
//
//  // Fade in function
//  const fadeIn = (element) => {
//   // Create variable with initial opacity
//   let elementOpacity = 0.1;
//
//   // Create timer for fadeIn function
//   let timer = setInterval(() => {
//    if (elementOpacity >= 1) {
//     // Reset interval
//     clearInterval(timer);
//    }
//
//    // Set element opacity to elementOpacity
//    element.style.opacity = elementOpacity;
//
//    // Increase value of elementOpacity
//    elementOpacity += elementOpacity * 0.1;
//
//    // Show element
//    element.style.display = 'block';
//   }, 15);
//  }
//
//  // Fade out function
//  const fadeOut = (element) => {
//   // Create variable with initial opacity
//   let elementOpacity = 1;
//
//   // Create timer for fadeOut function
//   let timer = setInterval(() => {
//    if (elementOpacity <= 0.1) {
//     // Reset interval
//     clearInterval(timer);
//
//     // Hide element
//     element.style.display = 'none';
//    }
//
//    // Set element opacity to elementOpacity
//    element.style.opacity = elementOpacity;
//
//    // Decrease value of elementOpacity
//    elementOpacity -= elementOpacity * 0.1;
//   }, 15);
//  }
//
//  // Open reveal dialog by clicking on images
//  for (let x = 0, y = galleryVariables.galleryLinks.length; x < y; x++) {
//   // Add event listener for image containers
//   galleryVariables.galleryLinks[x].addEventListener('click', (e) => {
//    e.preventDefault();
//
//    // Get clicked image
//    let image = e.target;
//
//    // Get src of the image
//    let imageSrc = image.getAttribute('src');
//
//    // Get alt of the image
//    let imageAlt = image.getAttribute('alt');
//
//    // Set alt attribute of preview image to clicked image
//    galleryVariables.galleryPreview.setAttribute('alt', imageAlt);
//
//    // Set src attribute of preview image to clicked image
//    galleryVariables.galleryPreview.setAttribute('src', imageSrc);
//
//    // Set preview headline to alt of clicked photo
//    galleryVariables.galleryPreviewAuthor.textContent = imageAlt;
//
//    // Avoid openning modal unless its content is loaded
//    if (galleryVariables.galleryPreview.getAttribute('src').length > 0 && galleryVariables.galleryPreview.getAttribute('alt').length > 0 && galleryVariables.galleryPreviewAuthor.textContent.length > 0) {
//     // Add Foundation class to hide overflow
//     document.body.classList.add('is-reveal-open');
//
//     // Show modal dialog
//     galleryVariables.galleryModal.style.display = 'block';
//
//     // Show modal overlay (fade it in)
//     fadeIn(galleryVariables.galleryOverlay);
//    }
//   });
//  }
//
//  // Close reveal dialog
//  galleryVariables.galleryButton.addEventListener('click', (e) => {
//   e.preventDefault();
//
//   // Hide modal overlay (fade it out)
//   fadeOut(galleryVariables.galleryOverlay);
//
//   // Wait before overlay fades out
//   setTimeout(() => {
//    // Hide modal dialog
//    galleryVariables.galleryModal.style.display = 'none';
//
//    // Reset alt attribute of preview image
//    galleryVariables.galleryPreview.setAttribute('alt', '');
//
//    // Reset src attribute of preview image
//    galleryVariables.galleryPreview.setAttribute('src', '');
//
//    // Reset text for preview headline
//    galleryVariables.galleryPreviewAuthor.textContent = '';
//
//    // Remove Foundation class to hide overflow
//    document.body.classList.remove('is-reveal-open');
//   }, 250);
//  });
// });
